// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { EntityEvent } from './entity-event';
import { EntityEventTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EntityEventType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: EntityEventTypeEnum;
  /** String(50) */
  name!: string;
  /** Inv FK entityEventTypeId */
  entityEvents!: EntityEvent[];
}

